import Home from '@/views/home/index.vue'
import Redirect from '@/views/redirect/index.vue'

export default [
  {
    path: '/',
    // component: () => import('@/views/home/index.vue')
    component: Home
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/redirect',
    name: 'redirect',
    // component: () => import('@/views/redirect/index.vue')
    component: Redirect
  }
]
